export const wizardDead = new Image();
wizardDead.src = "./assets/characterSprites/Evil_Wizard_2/Death28Frames.png";
wizardDead.width = 2000/8
// wizardDead.height = wizardDead.height/1
wizardDead.yOffset = -25
wizardDead.xOffset = -40
wizardDead.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];